import Address from '../model/project/address';
import AddressWithType, {
  AddressType
} from '../model/project/address-with-type';
import { CollectionHelper } from './collection-helper';
import { StringHelper } from './string-helper';

export default class AddressHelper {
  static splitIntoLineAndNumber(line1: string): string[] {
    if (line1 == null) {
      return null;
    }
    let match = this.NUMBER_REGEX.exec(line1);
    if (match == null) {
      return [line1];
    } else {
      return [
        line1.substring(0, match.index),
        line1.substring(match.index, line1.length)
      ];
    }
  }

  static isEmptyAddress(address: Address): boolean {
    return (
      address == null ||
      (StringHelper.isEmpty(address.line1) &&
        StringHelper.isEmpty(address.city) &&
        StringHelper.isEmpty(address.postalCode))
    );
  }

  static getAddressDisplay(address: any): string {
    const actualAddress = address.address == null ? address : address.address;
    return StringHelper.join(
      [
        actualAddress.line1,
        StringHelper.join([actualAddress.postalCode, actualAddress.city], ' ')
      ],
      ', '
    );
  }

  static getAddressPreferring(
    addresses: AddressWithType[],
    preferred: AddressType = 'primary'
  ) {
    if (!CollectionHelper.isPopulated(addresses)) {
      return null;
    }
    const firstFoundAddress = addresses[0];
    if (firstFoundAddress.type === preferred) {
      return firstFoundAddress;
    }
    for (let i = 1; i < addresses.length; i++) {
      const address = addresses[i];
      if (address.type === preferred) {
        return address;
      }
    }
    return firstFoundAddress;
  }

  private static NUMBER_REGEX = /[0-9]/;
}
